export enum AttendeesConfirmEnum {
  CONFIRMED = "confirmed",
  TRAINING_STARTED = "training_started",
  TRAINING_ENDED = "training_ended",
  REGISTERED = "registered",
  TO_COMPLETE = "to_complete",
  TO_VALIDATE = "to_validate",
}

export enum AttendeesPendingEnum {
  PROPOSAL_PENDING = "proposal_pending",
  PENDING = "pending",
  TO_BE_CONFIRMED = "to_be_confirmed",
  PENDING_EMPLOYEE = "pending_employee",
}

export enum SessionStatusEnum {
  PENDING_INVITATION = "pending_invitation",
  ENDED = "ended",
  UPCOMING = "upcoming",
  ONGOING = "ongoing",
  TO_COMPLETE = "to_complete",
  TO_VALIDATE = "to_validate",
  COMPLETED = "completed",
  FINISHED = "finished",
  NO_SHOW = "no_show",
  CANCELED = "canceled",
}

/** Placeholder sessionId the attendees endpoints return for rows that aren't real bookings. */
export const FAKE_SESSION_ID = "fake";

/** Buckets the basic-attendees list is split into on the session details store. */
export enum SessionAttendeesBucketEnum {
  ALL = "Tout",
  ABSENT = "Absents",
  REGISTERED = "Inscrits",
  PENDING = "En attente",
}

export enum SessionDetailsSatisfactionTypeEnum {
  DIRECT = "direct_pedagogical_report",
  DELAYED = "delayed_pedagogical_report",
}

export enum SessionDetailsTabNamesEnum {
  ADMIN = "Admin",
  PARTICIPANTS = "Participants",
  DOCUMENTS = "Documents",
  OTHER_COSTS = "Coûts",
  HABILITATIONS = "Habilitations",
  SURVEYS = "Enquêtes",
  NOTIFICATIONS = "Notifications",
  USER_VIEW = "Vue utilisateur",
}
